import { Drawer } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';

import { findWorkRecord, getInvoiceCommon } from '../../api/constlink';
import { useDispatch } from 'react-redux';
import WorkRecordCreateUpdateComponent from '../../components/work-records/WorkRecordCreateUpdateComponent';
import { createWorkRecordAsync } from '../../modules/work-records';
import {
  getWorkRecordFileAPIPath,
  initializeUploadProps,
} from '../../util/utils';
import Title from 'antd/lib/typography/Title';

interface WorkRecordCreateDrawerProps {
  enterpriseId: string;
  projectId: string;
  visible: boolean;
  onClose: () => void;
}

function WorkRecordCreateDrawer({
  enterpriseId,
  projectId,
  visible,
  onClose,
}: WorkRecordCreateDrawerProps) {
  const [invoiceCommon, setInvoiceCommon] = useState<any>();
  const [uploadProps, setUploadProps] = useState<any>();
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      const invoiceCommon = await getInvoiceCommon(enterpriseId);
      setInvoiceCommon({ ...invoiceCommon });
    })();

    (async () => {
      setUploadProps(
        await initializeUploadProps(
          getWorkRecordFileAPIPath(enterpriseId, projectId),
        ),
      );
    })();
  }, [enterpriseId, projectId]);

  const onCreate = async (data: any) => {
    const workRecordObj = {
      ...data,
      projectId: +projectId,
      createdDate: moment(data.createdDate).format('YYYY-MM-DD'),
    };

    if (workRecordObj.file) {
      for (const _file of workRecordObj.file) {
        if ('response' in _file) {
          _file.path = _file.response.path;
          _file.mimeType = _file.response.mimeType;
        }
      }
    }

    dispatch(
      createWorkRecordAsync.request({
        enterpriseId,
        projectId,
        workRecord: {
          ...workRecordObj,
        },
      }),
    );

    onClose();
  };

  const onCancel = () => {
    onClose();
  };

  const _findWorkRecord = async (createdDate: string) => {
    const result = await findWorkRecord({
      enterpriseId,
      projectId,
      createdDate,
    });
    return result;
  };

  return (
    <>
      <Drawer
        width={650}
        placement="right"
        closable={true}
        onClose={onClose}
        open={visible}
        maskClosable={false}
        title={<Title level={3}>작업일보 생성</Title>}
      >
        {visible && (
          <WorkRecordCreateUpdateComponent
            invoiceCommon={invoiceCommon}
            uploadProps={uploadProps}
            onCreate={onCreate}
            onCancel={onCancel}
            findWorkRecord={_findWorkRecord}
          />
        )}
      </Drawer>
    </>
  );
}

export default WorkRecordCreateDrawer;
